import { useQuery } from 'react-query'
import { getSettingsStructure } from 'services/cmAPI/getSettingsStructure'

export function useGetSettingsStructure() {
  return useQuery(['getSettingsStructure'], () => getSettingsStructure(), {})
}
